// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    buttonText: "Learn more about monday's AI offering",
    impactTitle: "Your teams’ impact. Multiplied by AI.",
    sectionVisibility: true,
    slide1Title: "Predict risks early",
    slide2Title: "Scale marketing output",
    slide3Title: "Boost sales velocity",
    slide4Title: "Resolve tickets faster",
    slide5Title: "Drive quality sprints",
    tab1Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    },
    tab2Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    },
    tab3Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    },
    tab4Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    },
    tab5Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    }
};
